var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJestLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 121,
    viewBox: "0 0 104 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "jest-logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "jest-logo_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5954 44.0294C57.5954 43.0882 68.1686 23.6372 73.4552 14.0294L88.7276 44.0294L104 1.08824L41.7356 0.5L57.5954 44.0294ZM9.42808 75.7941C6.29528 78.1471 0.0296751 86.1471 0.0296751 99.3235C-0.557439 110.5 7.66663 120.5 15.8899 120.5H23.5258C27.6379 120.5 38.7986 116.382 69.9305 101.088C79.9166 101.088 102.825 97.5588 102.825 84.6177V75.7941C102.825 74.0294 102.825 73.2451 100.475 74.0294C97.5383 75.0098 92.2523 75.7941 87.5528 74.6176C87.4901 74.5862 87.4245 74.5536 87.3562 74.5196C84.8625 73.2788 78.7104 70.2175 77.5667 59.9118H69.9305C69.3434 64.6176 64.6442 74.6176 58.7702 74.6176H51.7214C47.218 82.4608 33.5119 97.5588 24.7006 97.5588C20.0017 97.5588 9.89791 95.5589 9.42808 75.7941ZM12.9529 51.0882C7.66634 51.0882 4.72934 54.2647 4.72934 59.9117C4.72948 64.0294 7.07894 68.7353 12.9529 68.7353C17.6522 68.7353 21.1764 65.7941 21.1764 59.9117C21.1764 56.3823 19.4144 51.0882 12.9529 51.0882ZM85.7906 59.9117C85.7906 54.2647 88.7276 51.0882 94.0142 51.0882C100.476 51.0882 102.238 56.3823 102.238 59.9117C102.238 65.7941 98.7134 68.7353 94.0142 68.7353C88.1402 68.7353 85.7907 64.0294 85.7906 59.9117ZM54.071 51.0882C48.7844 51.0882 45.8474 54.2647 45.8474 59.9117C45.8475 64.0294 48.197 68.7353 54.071 68.7353C58.7702 68.7353 62.2945 65.7941 62.2945 59.9117C62.2945 56.3823 60.5324 51.0882 54.071 51.0882Z",
    fill: "url(#paint0_linear_38_282)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_38_282",
    x1: 24.0834,
    y1: 22.8529,
    x2: 100.537,
    y2: 88.0398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#056945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411057,
    stopColor: "#01A66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#01A66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#056945"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJestLogo);
export default __webpack_public_path__ + "static/media/jest-logo.f47bb97ca15b1685ff393a33f4174547.svg";
export { ForwardRef as ReactComponent };